import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { LegendListComponent } from '@connect-services/client/components/legend/legend-list/legend-list.component';
import { ContentLayoutService } from '@connect-services/client/services/content-layout.service';
import { LegendService } from '@connect-services/client/services/legend.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

const classContentUnderMap = [
    'map-one-third-horizontal',
    'map-puzzle-one-third-one-third',
    'map-puzzle-one-third-two-thirds',
    'map-puzzle-two-thirds-one-third',
    'map-puzzle-two-thirds-two-thirds',
    'map-two-thirds-horizontal',
];

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LegendListComponent, RessourcesModule],
    selector: 'app-legend-button',
    styleUrl: './legend-button.component.scss',
    templateUrl: './legend-button.component.html',
})
export class LegendButtonComponent {
    public readonly isContentOpenUnder = computed(() =>
        classContentUnderMap.includes(this.contentLayoutService.mapSizeType()?.class ?? ''),
    );

    protected contentLayoutService = inject(ContentLayoutService);
    protected readonly legendService = inject(LegendService);

    public toggleLegend(): void {
        this.legendService.isLegendOpen.update((value) => !value);
    }
}
